var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 100,
    viewBox: "0 0 76 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4715_12757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.88867 96.5185C3.01853 83.5787 5.96082 70.862 10.6294 58.7409C12.223 55.3418 14.8044 52.5021 18.0368 50.5928C20.0834 49.2998 22.3389 48.3724 24.7032 47.8521",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4434 98.8889L22.9991 94.0742C28.4778 92.3431 33.1051 88.6148 35.962 83.6297C39.3976 78.3771 43.1064 73.3085 47.0731 68.4446H47.5917C48.3276 67.9238 48.9447 67.2526 49.402 66.4756C49.8593 65.6986 50.1462 64.8335 50.2443 63.9373C50.3423 63.041 50.2488 62.1341 49.9703 61.2766C49.6918 60.4191 49.2348 59.6307 48.6289 58.9631C46.4807 56.4446 42.7769 54.5927 37.3695 60.2964C37.3695 60.2964 32.2583 68.5187 26.1842 69.4076H25.0734V5.92605C25.0734 4.70802 25.5571 3.53981 26.4184 2.67853C27.2797 1.81725 28.4479 1.3335 29.6659 1.3335H69.7398C70.9578 1.3335 72.126 1.81725 72.9873 2.67853C73.8486 3.53981 74.3324 4.70802 74.3324 5.92605V82.963C74.3324 84.1811 73.8486 85.3493 72.9873 86.2106C72.126 87.0718 70.9578 87.5556 69.7398 87.5556H34.3326",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 14.6665H74.2593",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 7.77783H51.4444",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5186 72.4443H74.1111",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5926 82.815C51.3108 82.815 52.7037 81.4221 52.7037 79.7039C52.7037 77.9857 51.3108 76.5928 49.5926 76.5928C47.8743 76.5928 46.4814 77.9857 46.4814 79.7039C46.4814 81.4221 47.8743 82.815 49.5926 82.815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5583 51.054C55.4266 51.054 60.9944 45.4861 60.9944 38.6178C60.9944 31.7495 55.4266 26.1816 48.5583 26.1816C41.6899 26.1816 36.1221 31.7495 36.1221 38.6178C36.1221 45.4861 41.6899 51.054 48.5583 51.054Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6127 54.9814L57.0674 47.127",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4715_12757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74.4444,
    height: 100,
    fill: "white",
    transform: "translate(0.777344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSearch);
export default __webpack_public_path__ + "static/media/phone-search.5aeeabcdc1d27a355c0fef25a32d6622.svg";
export { ForwardRef as ReactComponent };